const IconFacebook = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
            <path d="M10.65 2.156a3.469 3.469 0 0 0-3.469 3.469v1.931H5.325a.169.169 0 0 0-.169.169v2.55c0 .093.076.169.169.169h1.856v5.231c0 .093.076.169.169.169H9.9a.169.169 0 0 0 .169-.169v-5.231h1.872a.169.169 0 0 0 .164-.128l.638-2.55a.169.169 0 0 0-.164-.21h-2.51V5.625a.581.581 0 0 1 .581-.581h1.95a.169.169 0 0 0 .169-.169v-2.55a.169.169 0 0 0-.169-.169h-1.95Z" />
        </svg>
    );
};

export default IconFacebook;
